/*eslint-disable */

var fbId = 743207312503631;

var SocialShare  = {
  url: 'https://10years.lifehacker.ru/publisher/',
  title: 'Я попробовал себя в роли издателя Лайфхакера!',
  // description: 'Привет, у нас праздник.',
  picture: 'https://10years.lifehacker.ru/publisher/images/share.jpg',

  _share: function(url, params) {
    var left = Math.round(screen.width/2 - params.width/2);
    var top = 0;

    if (screen.height > params.height)
      top = Math.round(screen.height/3 - params.height/2);

    window.open(url, params.id, 'left=' + left + ',top=' + top + ',' +
      'width=' + params.width + ',height=' + params.height + ',personalbar=0,toolbar=0,scrollbars=1,resizable=1');
  },

  vk: function(text) {
    window.ga('send', 'event', 'Социальная активность', 'Клик с экрана результата', 'vkontakte')

    var url = 'https://vk.com/share.php?url=' + this.url
      + '&title=' + encodeURIComponent(this.title)
      + '&description=' + encodeURIComponent(text)
      + '&image=' + encodeURIComponent(this.picture)

    var params = {width:655, height:450, id:'popup-vk'}

    this._share(url, params)
  },

  fb: function(text) {
    window.ga('send', 'event', 'Социальная активность', 'Клик с экрана результата', 'facebook')

    var url =  'http://www.facebook.com/dialog/feed?app_id=' + fbId
      + '&link=' + this.url
      + '&picture=' + this.picture
      + '&name=' + encodeURIComponent(this.title)
      + '&description=' + encodeURIComponent(text)
      + '&redirect_uri=' + this.url
      + '&display=popup';

    var params = {width:600, height:359, id:'popup-fb'};

    this._share(url, params);
  },

  tw: function(text) {
    window.ga('send', 'event', 'Социальная активность', 'Клик с экрана результата', 'twitter')

    var url =  'http://twitter.com/share?text=' + this.title
      + ' ' + text + ' ' + '&url=' + this.url;

    var params = {width:655, height:450, id:'popup-tw'}

    this._share(url, params)
  },
};

export default SocialShare



// WEBPACK FOOTER //
// ./src/lib/share.js